import { render } from "./illuminationController.vue?vue&type=template&id=071d32f2&scoped=true"
import script from "./illuminationController.vue?vue&type=script&lang=js"
export * from "./illuminationController.vue?vue&type=script&lang=js"

import "./illuminationController.vue?vue&type=style&index=0&id=071d32f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071d32f2"]])

export default __exports__